import { createAction, createReducer, createSelector } from "@reduxjs/toolkit";
import { presetStateSelector } from "../utils/state.js";
export const updateInitStyle = createAction("init/updateStyle");
const initialState = {
    published: false,
    current: false,
    style: {
        id: 0,
        key: "",
        displayName: "",
        scope: "private",
        publishedVersionId: null,
        currentVersionId: null,
    },
};
/**
 * This reducer is populated in historyEnhancer
 * It is used to keep initial style in history
 */
export const initReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(updateInitStyle, (state, action) => {
        const { payload, } = action;
        state.style = payload;
    });
});
export const getInitState = createSelector([presetStateSelector], state => state.init);
export const getInitSpec = createSelector([getInitState], init => init.spec);
export const getInitStyle = createSelector([getInitState], init => init.style);
